export enum CuppingScoreCalculation {
  None = 0,
  Aggregated = 1,
  Average = 2,
}
